import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import { useTranslation } from 'react-i18next';

const gqlGet = gql`
  query getCntContributiontates($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributionstates(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: value
        description: name
        isActive
      }
      recordCount
    }
  }
`;

// export function useGetCompanyTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>) {
//   return ApolloReactHooks.useLazyQuery<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>(GetCompanyTypesDocument, baseOptions);
// }

function useGetLazyQuery() {
  return useLazyQuery(gqlGet, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

export const FieldSelectContributionState = ({
  label = 'Κατάσταση',
  name = 'statusId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  const { t } = useTranslation();
  return (
    <FieldSelectDB
      {...rest}
      label={t(label)}
      name={name}
      // @ts-ignore
      sbLabel={defaultValues?.contributionstate?.name ?? undefined}
      hook={useGetLazyQuery}
    />
  );
};

